import { useLang } from '@/i18n';
import EfFooterTc from '@elem/ui/ef-footer-tc';
import EfSpec from '@elem/ui/ef-spec';
import { useState } from 'react';
import styles from './index.module.scss';

export default function TheComp() {
    const { t } = useLang('theProduct.FootTC');
    const [list, setList] = useState<any[]>([
        {
            title: '尊敬的用户，请注意：\n因芯片兼容性问题，我们经过实际测试发现，以下型号的华硕笔记本电脑适配器在本产品上使用可能存在工作异常情况：\nA20-240P1-A\nADP-280BB-B\nADP-200JB-D\n以上电源适配器的用户我们建议您选择其他型号的正浩电源，以确保笔记本电脑的稳定运行和安全充电。如需进一步帮助，请随时联系我们的客户支持团队。感谢您的理解与合作。',
        },
        {
            title: '*续航时间、UPS切换时间是在使用普通家用电器在正常室温条件下进行，基于正浩内部测试所得。\n*仅指睿 RIVER 3相比于同类产品体积缩小30%。\n*噪音水平数据是根据在32°C的室温下进行的测试得出的，实际使用可能因实际环境的变化而有轻微的偏差。\n*睿 RIVER 3产品AC插口会根据当地法规和用电制式有所不同，请以实际为准。\n*睿 RIVER 3系列产品体积、重量数据来源于正浩内部测试所得，具体请以实际使用为准。\n*耐用年限数据基于正浩内部测试环境下测试的估算所得，具体数据可能会因为使用环境等原因产生差异，具体请以实际使用为准。\n*通过UN 38.3认证，睿 RIVER 3系列电源经过了严格的跌落、碰撞和振动测试从1米高度摔落后仍能保持完好无损。\n*对比市面上的同类未采用GaN技术产品，数据来源于正浩内部测试。\n*仅指电源中的电池包达到IP54防水，整机使用请注意防护，由于侵入液体而导致的损坏不在保修范围之内。',
        },
        {
            title: '部分产品参数为产品发布时的初步设定，最终成品规格可能会有所变化，但不会低于宣传参数，产品更新后，正浩会及时更新产品页面，请以页面更新情况为准。',
        },
        {
            title: '由于测量方法、产品批次、生产过程等因素的差异，实际产品参数可能与页面展示的参数存在微小差异。',
        },
        {
            title: '具体的产品使用方法、操作步骤、维护保养以及详细的技术参数，请以随产品附带的使用手册为准。在使用产品前请仔细阅读使用手册。',
        },
        {
            title: '充电时间为正浩内部测下测试所得，实际使用可能会和页面宣传有差异，请以实际使用为准。',
        },
    ]);

    return (
        <div className={styles.TheComp}>
            <EfSpec />
            <EfFooterTc list={list} />
        </div>
    );
}
